import { http } from "api/http";

type AddAttachment = {
  autFyaNoticeId?: number;
  data: FormData;
  responseId?: number;
};

const getAutProfileDetails = ({ queryKey }: any) => {
  return http.get("/automation", { params: { ...queryKey[1] } });
};

const getIncomeTaxForms = ({ queryKey }: any) => {
  return http.get("/incometax/forms", { params: { ...queryKey[1] } });
};

const exportIncomeTaxForms = (data: any) => {
  return http.post("/incometax/export-forms", data);
};

const getFormData = ({ queryKey }: any) => {
  return http.get(`/incometax/form/${queryKey[1]}`);
};

const addAutClientCredentials = (data: any) => {
  return http.post("/incometax/credentials", data);
};

const updateAutClientCredentials = ({ id, data }: any) => {
  return http.put(`/incometax/credentials/${id}`, data);
};

const updateAppHierarchy = ({ id, data }: any) => {
  return http.put(`/approval-hierarchy/${id}`, data);
};

const getAutClientsCredentials = ({ queryKey }: any) => {
  return http.get("/incometax/credentials", { params: { ...queryKey[1] } });
};

const exportAutClientsCredentials = (data: any) => {
  return http.post("/incometax/export-credentials", data);
};

const getClientCredential = ({ queryKey }: any) => {
  return http.get(`incometax/credential/${queryKey[1]}`);
};

const getClientPortalCredential = ({ queryKey }: any) => {
  console.log(queryKey)
  return http.get(`incometax/credential/${queryKey[1]}`, { params: { clientId: queryKey[1] } });
};

const getIncomeTaxProfile = ({ queryKey }: any) => {
  return http.get(`incometax/profile/${queryKey[1]}`);
};

const getIncomeTaxJurisdiction = ({ queryKey }: any) => {
  return http.get(`incometax/jurisdiction/${queryKey[1]}`);
};

const getAllClients = ({ queryKey }: any) => {
  return http.get("incometax/clients", { params: { ...queryKey[1] } });
};

const getClientForm = ({ queryKey }: any) => {
  return http.get(`incometax/clientform/${queryKey[1]}`, { params: queryKey[2] });
};

const exportClientForm = (data: any) => {
  return http.post("incometax/clientformexport", data);
};

const getClientReturn = ({ queryKey }: any) => {
  /////////////
  return http.get(`incometax/clientreturn/${queryKey[1]}`, { params: queryKey[2] });
};

const exportIncomeTaxClientReturnsexport = (data: any) => {
  return http.post("incometax/clientreturn/clientreturnexport", data);
};

const getIncomeTaxReturns = ({ queryKey }: any) => {
  return http.get("/incometax/returns", { params: { ...queryKey[1] } });
};

const exportIncomeTaxReturns = (data: any) => {
  return http.post("/incometax/incometax-returns", data);
};

const getReturnData = ({ queryKey }: any) => {
  return http.get(`/incometax/return/${queryKey[1]}`);
};

//DEMANDS
const getIncomeTaxDemands = ({ queryKey }: any) => {
  return http.get("/incometax/demands", { params: { ...queryKey[1] } });
};

const exportIncomeTaxDemands = (data: any) => {
  return http.post("/incometax/export-demands", data);
};

const getDemandsSections = () => {
  return http.get("incometax/sections-demands");
};

const getDemandData = ({ queryKey }: any) => {
  return http.get(`/incometax/demand/${queryKey[1]}`);
};

const getClientDemand = ({ queryKey }: any) => {
  return http.get(`incometax/clientdemand/${queryKey[1]}`, { params: queryKey[2] });
};
const exportclientDemand = (data: any) => {
  return http.post("/incometax/export-clientdemand", data);
};

//E_PROCEEDINGS
const getIncomeTaxEproceedings = ({ queryKey }: any) => {
  return http.get("/incometax/action", { params: { ...queryKey[1] } });
};

const exportIncomeTaxEproceedings = (data: any) => {
  return http.post("/incometax/export-action", data);
};

const getIncomeTaxEproceedingsFyi = ({ queryKey }: any) => {
  return http.get("/incometax/information", { params: { ...queryKey[1] } });
};

const exportIncomeTaxEproceedingsFyi = (data: any) => {
  return http.post("/incometax/export-information", data);
};

const getEproceedingData = ({ queryKey }: any) => {
  return http.get(`/incometax/proceeding/${queryKey[1]}`);
};

const getEproceedingFyiData = ({ queryKey }: any) => {
  return http.get(`/incometax/information-pro/${queryKey[1]}`);
};

// Client Proceeding Find Your Action
const getClientproceedingFya = ({ queryKey }: any) => {
  return http.get(`/incometax/clientproceedingfya/${queryKey[1]}`, { params: queryKey[2] });
};

const exportClientproceedingFya = (data: any) => {
  return http.post("/incometax/clientfyareport", data);
};

//SECTION DATA
const getFyiSections = () => {
  return http.get(`/incometax/sections-fyi`);
};

const getFyaSections = () => {
  return http.get(`/incometax/sections-fya`);
};

const getClientproceedingFyi = ({ queryKey }: any) => {
  return http.get(`/incometax/clientproceedingfyi/${queryKey[1]}`, {
    params: queryKey[2], // Passing query parameters
  });
};

const exportClientproceedingFyi = (data: any) => {
  return http.post("/incometax/clientfyireport", data);
};

const getClientEproceeding = ({ queryKey }: any) => {
  return http.get(`incometax/clientproceeding/${queryKey[1]}`);
};

const getIncomeTaxEproceedingNotice = ({ queryKey }: any) => {
  return http.get(`/incometax/proceeding/notice-action/${queryKey[1]}`);
};

const getIncomeTaxEproceedingNoticeFyi = ({ queryKey }: any) => {
  return http.get(`/incometax/proceeding/notice-information/${queryKey[1]}`);
};

const sendActivityData = (data: any) => {
  return http.post(`/incometax/activity`, data);
};

const getActivityLogData = ({ queryKey }: any) => {
  return http.get(`/incometax/activity/${queryKey[1]}`, { params: { ...queryKey[2] } });
};

const getActivityArchiveData = ({ queryKey }: any) => {
  return http.get(`/incometax/activityArchive/${queryKey[1]}`, { params: { ...queryKey[2] } });
};

const createRequest = ({ id, data }: any) => {
  return http.post(`/automation/auto-machine/${id}`, data);
};

const getClientAutoStatus = ({ queryKey }: any) => {
  return http.get(`/automation/clientAutoStatus/${queryKey[1]}`);
};

const bulkAutomationSync = (data: any) => {
  return http.post(`/automation/bulkSync`, data);
};

const checkNoOfSync = () => {
  return http.get(`/incometax/checkNoOfSync`);
};

const getIncomeTaxReports = ({ queryKey }: any) => {
  return http.get(`/automation/reports`, { params: { ...queryKey[1] } });
};

const exportIncomeTaxReports = (data: any) => {
  return http.post(`/automation/export-reports`, data);
};
const importCredentials = (data: any) => {
  return http.post(`/incometax/import`, data);
};

const getIncomeTaxNewUpdates = ({ queryKey }: any) => {
  return http.get(`/automation/new-updates`, { params: { ...queryKey[1] } });
};

const getFyaNotice = ({ queryKey }: any) => {
  return http.get(`/automation/fya-notice`, { params: { ...queryKey[1] } });
};

const getEproceedingNotice = ({ queryKey }: any) => {
  return http.get(`/automation/eproceeding-notice`, { params: { ...queryKey[1] } });
};
const exportEproceedingNotice = (data: any) => {
  return http.post(`/automation/export-eproceeding-notice`, data);
};
const getNewUpdateItem = ({ queryKey }: any) => {
  return http.get(`/automation/update/${queryKey[1]}`);
};

const organizationScheduling = () => {
  return http.get(`/incometax/scheduling`);
};

const sendAtomProLimitRequest = () => {
  return http.post(`/automation/limitRequest`);
};

const sendAtomProRequest = (data: any) => {
  return http.post(`/automation/sendAtomProRequest`, data);
};

//e-Challan
const getClientEchallan = ({ queryKey }: any) => {
  return http.get(`incometax/clientechallan/${queryKey[1]}`, { params: queryKey[2] });
};
const exportClientEchallan = (data: any) => {
  return http.post("incometax/clientechallanexport", data);
};

const getEChallanData = ({ queryKey }: any) => {
  return http.get(`/incometax/e-challan/${queryKey[1]}`);
};

const getIncomeTaxEchallans = ({ queryKey }: any) => {
  return http.get("/incometax/e-challans", { params: { ...queryKey[1] } });
};

const exportIncometaxEchallan = (data: any) => {
  return http.post("incometax/incometaxechallanexport", data);
};

//My Chartrered Accountant(s)
const getClientMycas = ({ queryKey }: any) => {
  return http.get(`incometax/mycas/${queryKey[1]}`, { params: queryKey[2] });
};

const exportClientMycas = (data: any) => {
  return http.post("incometax/mycas/mycasexport", data);
};

const getIncomeTaxMycas = ({ queryKey }: any) => {
  return http.get("/incometax/my-cas", { params: { ...queryKey[1] } });
};
const exportIncometaxMyCas = (data: any) => {
  return http.post("incometax/mycas/incometaxmycaexport", data);
};

const getMyCaFormTypes = () => {
  return http.get(`/incometax/form-types`);
};

//Temp Notices

const getIncomeTaxTempNoticeFyi = ({ queryKey }: any) => {
  return http.get("/incometax/temp-notice-fyi", { params: { ...queryKey[1] } });
};
const exportIncomeTaxTempEproceedingsFyi = (data: any) => {
  return http.post("/incometax/tempproceedingTempfyI-export", data);
};

const getIncomeTaxTempNoticeFya = ({ queryKey }: any) => {
  return http.get("/incometax/temp-notice-fya", { params: { ...queryKey[1] } });
};
const exportIncomeTaxTempEproceedingsFyA = (data: any) => {
  return http.post("/incometax/tempproceedingTempfyA-export", data);
};

const getClientExcelproceedingFyi = ({ queryKey }: any) => {
  return http.get(`/incometax/clientproceedingfyi-excel/${queryKey[1]}`, {
    params: queryKey[2], // Passing query parameters
  });
};
const exportClientTempNoticeFYI = (data: any) => {
  return http.post("/incometax/clientproceedingfyI-export", data);
};
const getClientExcelproceedingFya = ({ queryKey }: any) => {
  return http.get(`/incometax/clientproceedingfya-excel/${queryKey[1]}`, { params: queryKey[2] });
};

const exportClientTempNoticeFYA = (data: any) => {
  return http.post("/incometax/clientproceedingfya-export", data);
};
const getExcelFyiSections = () => {
  return http.get(`/incometax/sections-fyi-excel`);
};

const getExcelFyaSections = () => {
  return http.get(`/incometax/sections-fya-excel`);
};

const getExcelEproceedingNotice = ({ queryKey }: any) => {
  return http.get(`/automation/eproceeding-notice-excel`, { params: { ...queryKey[1] } });
};
const exportEproceedingExcelNotice = (data: any) => {
  return http.post("/automation/exportEproceedingExcelNotice-export", data);
};

const syncFailedModules = (data: any) => {
  return http.post(`/automation/sync-fail`, data);
};

const createFyaItem = (data: any) => {
  return http.post(`/incometax-config/fyaItem`, data);
};

const updateFyaItem = (data: any) => {
  return http.put(`/incometax-config/fyaItem`, data);
};

const deleteFyaItem = ({ id }) => {
  return http.delete(`incometax-config/fyaItem/${id}`);
};

const deleteManualResponse = ({ id }) => {
  return http.delete(`incometax-config/deleteResponse/${id}`);
};

const addFyaAttachment = ({ autFyaNoticeId, data }: AddAttachment) => {
  return http.post(`/incometax/${autFyaNoticeId}/attachments`, data);
};

const manualAttachmentsDelete = ({ id, gstrId }) => {
  return http.delete(`/storage/remove-file/${id}`,
    {
      params: { gstrId }
    }
  );
};

export {
  exportEproceedingExcelNotice,
  exportIncomeTaxTempEproceedingsFyA,
  exportIncomeTaxTempEproceedingsFyi,
  exportClientTempNoticeFYI,
  exportClientTempNoticeFYA,
  exportIncometaxEchallan,
  exportIncometaxMyCas,
  exportClientproceedingFyi,
  exportClientproceedingFya,
  exportclientDemand,
  exportClientEchallan,
  exportClientForm,
  exportClientMycas,
  exportIncomeTaxClientReturnsexport,
  exportIncomeTaxReports,
  exportEproceedingNotice,
  exportIncomeTaxEproceedingsFyi,
  exportIncomeTaxEproceedings,
  exportIncomeTaxDemands,
  exportIncomeTaxForms,
  exportIncomeTaxReturns,
  exportAutClientsCredentials,
  getAutProfileDetails,
  getIncomeTaxForms,
  getFormData,
  addAutClientCredentials,
  getAutClientsCredentials,
  getClientCredential,
  getAllClients,
  getIncomeTaxProfile,
  getClientForm,
  getIncomeTaxReturns,
  getReturnData,
  getClientReturn,
  getIncomeTaxDemands,
  getDemandData,
  getClientDemand,
  getIncomeTaxEproceedings,
  getEproceedingData,
  getClientEproceeding,
  getIncomeTaxEproceedingNotice,
  getIncomeTaxEproceedingsFyi,
  getClientproceedingFya,
  getClientproceedingFyi,
  getEproceedingFyiData,
  getIncomeTaxEproceedingNoticeFyi,
  getFyiSections,
  getFyaSections,
  getDemandsSections,
  getIncomeTaxJurisdiction,
  updateAutClientCredentials,
  sendActivityData,
  getActivityLogData,
  getActivityArchiveData,
  createRequest,
  getClientAutoStatus,
  bulkAutomationSync,
  checkNoOfSync,
  getIncomeTaxReports,
  importCredentials,
  getIncomeTaxNewUpdates,
  getFyaNotice,
  getEproceedingNotice,
  getNewUpdateItem,
  getClientPortalCredential,
  organizationScheduling,
  sendAtomProLimitRequest,
  sendAtomProRequest,
  getClientEchallan,
  getEChallanData,
  getIncomeTaxEchallans,
  getClientMycas,
  getIncomeTaxMycas,
  getMyCaFormTypes,
  getIncomeTaxTempNoticeFyi,
  getIncomeTaxTempNoticeFya,
  getClientExcelproceedingFyi,
  getClientExcelproceedingFya,
  getExcelFyiSections,
  getExcelFyaSections,
  getExcelEproceedingNotice,
  syncFailedModules,
  createFyaItem,
  updateFyaItem,
  deleteFyaItem,
  addFyaAttachment,
  deleteManualResponse,
  manualAttachmentsDelete
};
